import Dropdown, { MenuItem } from '@trendmicro/react-dropdown';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';
import styled from '@emotion/styled';

const Toggle = styled(Dropdown.Toggle)`
  padding-top: 20px;
  border: 0;
  font-size: 13px;
`;

const Menu = styled(Dropdown.Menu)`
  margin-top: 16px;
  border: 0;
  font-size: 13px;
`;

export {
    Dropdown,
    Toggle,
    Menu,
    MenuItem
};
